import { createSlice } from "@reduxjs/toolkit";
import { ApiCall, ApiCallStatus, getHateoasElement, MethodType } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { createAppAsyncThunk } from "@myRedux/createAppAsyncThunk";
import { ApiResource } from "@myRedux/api/apiSlice";
import { getErrorMessage } from "app/error";
import { updateUrlParamEntry } from "app/urlUtility";

const initialState = {
  status: ApiCallStatus.Idle,
} as ApiCall;

export type VerifyUserEmailArg = {
  resourceRel: ApiResource,
  token: string
};

export const verifyUserEmailAsync = createAppAsyncThunk(
  'user/verifyUserEmail',
  async (arg: VerifyUserEmailArg, thunkAPI) => {
    try {
      const relHateoasElement = getHateoasElement(arg.resourceRel, 'verify_user_email', MethodType.PUT);
      if (relHateoasElement) {
        const urlParts = relHateoasElement.href.split('?');
        const urlParams = new URLSearchParams(urlParts[1]);
        updateUrlParamEntry('token', arg.token, urlParams);
        const reconstructedUrl = urlParts[0] + '?' + urlParams.toString();
        const response = await thunkAPI.extra.apiClient.put(reconstructedUrl, null);
        if (response.hasError()) {
          return thunkAPI.rejectWithValue(response.statusText);
        }
        return response.data;
      }
      return thunkAPI.rejectWithValue(`No 'verify_user_email' HATEOAS link`);
    }
    catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

export const verifyUserEmailSlice = createSlice({
  name: 'userSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyUserEmailAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(verifyUserEmailAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
      })
      .addCase(verifyUserEmailAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.error = action.payload
        handleSliceRejectionDefault(action);
      })
  },
});

export const selectVerifyUserEmail = (state: RootState) => state.user.verifyUserEmail;

export default verifyUserEmailSlice.reducer;